import create from 'zustand';
import { IUser } from '@root/types/user';
import { USER_INFO } from '@root/constant';

interface ILoginState {
  username: string;
  password: string;
  errorInfo: string;
}

export interface IState {
  loginState: ILoginState;
  user: IUser;
  setUser: (v: IUser) => void;
  setLoginState: (v: any) => void;
  resetInitData: () => void;
  resetLoginState: () => void;
}

let initData = {};

try {
  initData = JSON.parse(window.localStorage.getItem(USER_INFO) || '{}');
} catch (error) {
  initData = {};
}

const useUser = create<IState>((set) => ({
  loginState: {
    username: '',
    password: '',
    errorInfo: '',
  },
  user: initData,
  setLoginState: (data: any) => {
    return set((state) => {
      return {
        loginState: {
          ...state.loginState,
          ...data,
        },
      };
    });
  },
  setUser: (user: IUser) => {
    return set(() => {
      return {
        user,
      };
    });
  },
  resetLoginState: () => {
    return set(() => {
      return {
        loginState: {
          username: '',
          password: '',
          errorInfo: '',
        },
      };
    });
  },
  resetInitData: () => {
    return set(() => {
      return {
        user: {},
      };
    });
  },
}));

export default useUser;
